// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdGetAssetMetadataResult = objectOf({
  name: string,
  width: number,
  height: number,
  size: number,
  mime_type: string,
});
